import { routeMap } from '../analytics/routeMap';
import { isDesktop } from '../utils/deviceType';
import pageName from '../utils/pageName';
import enableSplunkTracking from '../utils/splunkObservabilityTracking';

export default {
  methods: {
    pageView(page = '') {
      if (this.$route && this.$route.name && routeMap[this.$route.name] && this.$coa.token) {
        this.$coa.pageView({
          deviceType: isDesktop() ? 'desktop' : 'mobile',
          pageId: routeMap[page || this.$route.name],
          pageName: pageName(page, this.$route.query)
            || pageName(this.$route.name, this.$route.query),
          adgid: this.$route.query.utm_adgid || '',
          gclid: this.$route.query.gclid || '',
          source: this.$route.query.utm_source || '',
          referral: this.$route.query.referral || '',
        });
      }
      enableSplunkTracking();
    },
  },
};
